module.exports = __webpack_public_path__ + "static/media/wallet_loginTop_cut.f281f510.jpg";